<template>
  <div>
    <section id="wat-wij-doen" class="content-wrapper page">
      <section class="row header">
        <ul class="breadcrumb">
          <li><router-link class="link" to="/">Home</router-link></li>

          <li>
            <inline-svg src="/images/icons/chevron-right-solid.svg"></inline-svg
            >Hoe doen wij dat
          </li>
        </ul>
        <div class="col text">
          <h1>Hoe doen wij dat</h1>
          <h2>Makkelijk en snel</h2>
          <p>
            Print uitbesteden is bij ons in betrouwbare, veilige en ervaren
            handen. Wij voeren alle printopdrachten uit in eigen beheer vanuit
            onze vijf vestigingen verspreid over het land. Onder supervisie van
            uw persoonlijke contactpersoon bij Rijnja, verzorgen wij uw print-
            en repro-opdrachten makkelijk en snel van de voorbereiding tot de
            distributie met eigen koeriers en levering binnen een werkdag. Wij
            adviseren en richten voor u een op maat gemaakt bestelportal in.
            Vanaf dat moment bent u klaar voor ons super efficiënte klik & klaar
            bestelproces.
          </p>
        </div>
        <div class="image col">
          <img
            class="bestellen-bezorgen"
            src="@/images/pages/bestellen-bezorgen.svg"
          />
          <div class="bg-circle g-w"></div>
        </div>
      </section>

      <section id="bestelproces" class="row reverse">
        <div class="col text">
          <h2>Betrouwbare kwaliteit</h2>
          <p>
            Als marktleider investeren wij voortdurend in vernieuwende
            technologie en duurzame printtechnieken voor veilige en innovatieve
            online-oplossingen. Wij werken volgens de hoogste en nieuwste
            kwaliteits- en milieumanagementnormen. Vanzelfsprekend zijn wij ISO
            9001:2015 en ISO 14001:2015 gecertificeerd. We waarborgen de
            beveiliging en vertrouwelijkheid van uw bestanden en gegevens
            gedurende het gehele proces. Niet voor niets zijn wij gecertificeerd
            volgens de laatste norm, ISO 27001:2022.
          </p>
        </div>
        <div class="col image">
          <img
            class="kwaliteit"
            src="@/images/pages/kwaliteit-duurzaamheid-betrouwbaarheid.svg"
          />
        </div>
      </section>

      <section id="bestelproces" class="row">
        <div class="col text">
          <h2>Zorg voor het milieu</h2>
          <p>
            Naast de ISO certificeringen worden andere duurzaamheidsmaatregelen
            toegepast. Zo gebruiken wij FSC gecertificeerd papier en
            klimaatneutraal geproduceerd verpakkingsmateriaal. In onze vijf
            vestigingen maken we de impact op het milieu zo klein mogelijk door
            optimaal gebruik te maken van duurzame energiebronnen en de
            CO2-uitstoot te beperken. Een van onze locaties is inmiddels
            volledig zelfvoorzienend. In 2022-2023 is het gehele machinepark
            vervangen door energiezuinige state-of-the-art apparatuur.
          </p>

          <router-link class="link-button" to="/duurzaam"
            >Lees meer over duurzaamheid</router-link
          >
        </div>
        <div class="col image">
          <img class="duurzaam" src="@/images/pages/rijnja-duurzaam.svg" />
        </div>
      </section>

      <section id="bestelproces" class="row reverse">
        <div class="col text">
          <h2>Rijnja Ecoscore</h2>
          <p>
            Onze visie op duurzaamheidsprincipes reikt verder dan onze eigen
            organisatie. Wij willen ook bijdragen aan de
            ketenverantwoordelijkheid. Rijnja Ecoscore is een uniek en zelf
            ontwikkeld systeem waarmee we onze klanten helpen een verantwoorde
            en milieuvriendelijke(r) materiaalkeuze te maken. Op basis van
            onderzoek naar materiaaleigenschappen en herbruikbaarheid van
            verschillende rolmedia en plaatmateriaal is een classificatie
            gemaakt. Daarnaast zijn criteria opgesteld ten aanzien van
            grondstoffen, herbruikbaarheid, energie en CO2, herkomst en
            transport. Koninklijke Rijnja verzorgt de distributie met eigen
            elektrisch vervoer en ziet erop toe dat leveranciers en
            ingeschakelde transportbedrijven aan de strengste milieunormen
            voldoen.
          </p>
        </div>
        <div class="col image">
          <img class="kwaliteit" src="@/images/pages/ecoscore-logo.svg" />
        </div>
      </section>

      <section class="row" id="contact">
        <div class="col-single">
          <h1>Wilt u meer weten over onze diensten?</h1>
          <p>
            Benieuwd naar wat Koninklijke Rijnja voor u kan betekenen? Neem dan
            contact met ons op via onderstaand formulier.
          </p>

          <contact-form
            recipient="verkoop@rijnja.nl"
            class="form"
            subject="Informatieaanvraag diensten"
            conversion-id="McMQCKuxhJwYEKDetesD"
          ></contact-form>
          <p>
            Wilt u een van onze vestigingen direct bereiken? Bekijk de
            contactgegevens dan op onze
            <router-link class="link-text" to="/contact"
              >contactpagina</router-link
            >.
          </p>
        </div>
      </section>
    </section>
    <site-footer></site-footer>
  </div>
</template>

<script>
import ContactForm from '../../components/ContactForm.vue'
import SiteFooter from '../../components/SiteFooter.vue'
import PrintenEnMeer from './PrintenEnMeer.vue'
export default {
  components: { SiteFooter, PrintenEnMeer, ContactForm }
}
</script>

<style lang="scss" scoped>
.archiveren {
  max-width: 360px;
}
.bestellen-bezorgen {
  max-width: 375px;
}

.kwaliteit {
  max-width: 370px;
}

.security {
  max-width: 400px;
}

.printstore {
  max-width: 365px;
}

.duurzaam {
  max-width: 450px;
}

.form {
  margin: 25px 0;
}
</style>
